import warningSvg from 'assets/icons/warning.svg';
import { DealItem } from 'components/common/types/DealItem';
import { warningDealStatuses } from 'consts/ooc';
import Tooltip, { TooltipDirection } from 'lib/Tooltip';
import SVG from 'react-inlinesvg';

const OutOfChargeRenderer: React.FC<DealItem> = ({ data }) => {
  if (!data?.includesDischargedFrames) return null;
  if (!data.bookingStatusCode || !warningDealStatuses.includes(data.bookingStatusCode)) return null;

  return (
    <div data-test-id="OutOfChargeRenderer-wrapper">
      <Tooltip
        tooltip={
          <>
            Frames within this deal have been marked as out of charge.
            <br /> Reallocate your deal to avoid under-pacing.
          </>
        }
        direction={TooltipDirection.BOTTOM}
      >
        <SVG src={warningSvg} className="inline-block text-center leading-tight align-middle text-warning w-5 h-5" />
      </Tooltip>
    </div>
  );
};
export default OutOfChargeRenderer;
